import React, { useState, useEffect } from "react";
import { Button, Drawer, Modal } from "antd";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useLocation, useNavigate } from "react-router-dom";

import Logo from "../../assets/images/logo.png";
import CoociesIcon from "../../assets/images/cookie-icons.svg";

const HERO_PASSED_PX = 480; // roughly the hero's height — CTA appears once it's scrolled out of view

export default function HeaderIndex() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [CookieisModalOpen, setIsModalOpenCookie] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [heroPassed, setHeroPassed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // The dedicated /book-demo page doesn't need a mini CTA pointing at itself.
  const onBookDemoPage = location.pathname.startsWith("/book-demo");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 16);
      setHeroPassed(window.scrollY > HERO_PASSED_PX);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const CookieshowModal = () => {
    setIsModalOpenCookie(true);
  };

  const CookiehandleOk = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsModalOpenCookie(false);
  };

  const CookiehandleCancel = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsModalOpenCookie(false);
  };

  useEffect(() => {
    document.body.classList.add("imergey-body");
    return () => {
      document.body.classList.remove("imergey-body");
    };
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('cookieConsent')) {
      CookieshowModal();
    }
  }, []);

  return (
    <>
      <Navbar expand="lg" className={`header-main ${scrolled ? "header-main-scrolled" : ""}`}>
        <Container>
          <Navbar.Brand href="#" className="p-0 m-0">
            <div className="logo-image">
              <img src={Logo} alt="Logo" />
            </div>
          </Navbar.Brand>

          {!onBookDemoPage && (
            <button
              className={`header-mini-cta d-none d-lg-inline-flex ${heroPassed ? "header-mini-cta-in" : ""}`}
              onClick={() => navigate("/book-demo")}
              tabIndex={heroPassed ? 0 : -1}
              aria-hidden={!heroPassed}
            >
              Book a Demo
            </button>
          )}

          <div className="d-lg-none ms-auto mobile-header-actions">
            <Button
              className="menu-toggle"
              type="text"
              onClick={() => setIsDrawerOpen(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </Button>
          </div>

          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
            <Nav className="mx-auto navbar-menu">
              <Nav.Link href="#" className="menu-link active">
                Home
              </Nav.Link>
              <Nav.Link href="#whatwedo" className="menu-link">
                What we do
              </Nav.Link>
              <Nav.Link href="#howitwork" className="menu-link">
                How it works
              </Nav.Link>
              <Nav.Link href="#faq" className="menu-link">
                FAQ's
              </Nav.Link>
            </Nav>
            <div className="header-buttons">
              <Button
                className="fill-btn"
                onClick={() =>
                  window.open(process.env.REACT_APP_BRAND_LOGIN_URL, "_blank")
                }
              >
                Brand Login
              </Button>
              <Button
                className="outline-btn"
                onClick={() =>
                  window.open(process.env.REACT_APP_CLIENT_LOGIN_URL, "_blank")
                }
              >
                Client Login
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="mobile-login-bar d-lg-none">
        <Button
          className="fill-btn"
          onClick={() =>
            window.open(process.env.REACT_APP_BRAND_LOGIN_URL, "_blank")
          }
        >
          Brand Login
        </Button>
        <Button
          className="outline-btn"
          onClick={() =>
            window.open(process.env.REACT_APP_CLIENT_LOGIN_URL, "_blank")
          }
        >
          Client Login
        </Button>
      </div>

      <Drawer
        width={"100%"}
        placement="right"
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
        className="mobile-menu-drawer"
      >
        <Nav className="flex-column mobile-menu">
          <Nav.Link
            href="#"
            className="menu-link active"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              setIsDrawerOpen(false);
            }}
          >
            Home
          </Nav.Link>
          <Nav.Link
            href="#whatwedo"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            What we do
          </Nav.Link>
          <Nav.Link
            href="#howitwork"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            How it works
          </Nav.Link>
          <Nav.Link
            href="#faq"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            FAQ's
          </Nav.Link>
          <div className="header-buttons mt-4">
            <Button
              className="fill-btn mb-2 w-100"
              onClick={() =>
                window.open(process.env.REACT_APP_BRAND_LOGIN_URL, "_blank")
              }
            >
              Brand Login
            </Button>
            <Button
              className="outline-btn w-100"
              onClick={() =>
                window.open(process.env.REACT_APP_CLIENT_LOGIN_URL, "_blank")
              }
            >
              Client Login
            </Button>
          </div>
        </Nav>
      </Drawer>

      <Modal title="" open={CookieisModalOpen} footer={false} closable={false}>
        <div className="coocies-main-modal">
          <img src={CoociesIcon} alt="" />
          <h6>Cookie Consent</h6>
          <p>We use necessary cookies to make our site work. We'd like to set additional cookies to understand site usage, make site improvements and to remember your settings. We also use cookies set by other sites to help deliver content from their services.</p>
          <div className="coocies-footer-modal">
            <Button onClick={CookiehandleOk} className="fill-btn">Accept & continue</Button>
            <Button onClick={CookiehandleCancel} className="outline-btn">Decline cookies</Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
